import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconSolverHydraulicsSizeM from './IconSolverHydraulics_size_m';

const props: CreateIconArguments = {
  l: IconSolverHydraulicsSizeM,
  m: IconSolverHydraulicsSizeM,
  s: IconSolverHydraulicsSizeM,
  xs: IconSolverHydraulicsSizeM,
  name: 'IconSolverHydraulics',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
